import { render } from "./index.vue?vue&type=template&id=15c883c6&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=15c883c6&lang=scss"

import exportComponent from "D:\\project_h5\\mydyH5_Code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__